var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block",class:[
    { 'flex items-center' : _vm.inline}
  ]},[(_vm.label)?_c('span',{staticClass:"text-gray-700"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('div',{staticClass:"flex",class:[
        { 'flex-col space-y-1': !_vm.inline && !_vm.grid},
        { 'flex-row space-x-4': _vm.inline},
        { 'grid grid-cols-4': _vm.grid } ]},_vm._l((_vm.items),function(option){return _c('div',{key:option.value()},[_c('m-radio-item',{attrs:{"id":_vm.idAttr(option),"option":option,"modelValue":_vm.modelValue},on:{"change":function($event){return _vm.$emit('change', $event)}}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }